module.exports = __webpack_public_path__ + "static/media/uy.e538e316.svg";